import DOMPurify from 'dompurify'

const RICH_TEXT_CONFIG = {
  ALLOWED_TAGS: ['p', 'strong', 'em', 's', 'ul', 'ol', 'li', 'a', 'h1', 'h2', 'h3', 'br', 'span'],
  ALLOWED_ATTR: ['href', 'target', 'rel', 'class', 'style', 'data-mention-id', 'data-mention-type'],
  RETURN_DOM_FRAGMENT: false as const,
  RETURN_DOM: false as const,
}

export function sanitizeRichTextHtml(html: string): string {
  return DOMPurify.sanitize(html, RICH_TEXT_CONFIG)
}
